module.exports = __webpack_public_path__ + "static/2005-layer-1-7e69a9de03b88a1496f5bb9fab55afea.png";